/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import Advisor from '../components/advisor';
import AnchorTag from '../components/anchorTag';
import BlogNews from '../components/blogNews';
import BreadcrumbBar from '../components/breadcrumbBar';
import BuildAndPriceExternalLink from '../components/buildAndPriceExternalLink';
import CardCarousel from '../components/cardCarousel';
import CardColumnLayout from '../components/cardColumnLayout';
import CardGrid from '../components/cardGrid';
import CustomHtml from '../components/customHtml';
import DealerLocatorBreadcrumbBar from '../components/dealerLocatorBreadcrumbBar';
import DealerLocatorDetail from '../components/dealerLocatorDetail';
import DealerLocatorLanding from '../components/dealerLocatorLanding';
import DownloadBrochures from '../components/downloadBrochures';
import EventDetail from '../components/eventDetail';
import EventsListing from '../components/eventsListing';
import ExternalComponent from '../components/externalComponent';
import FairHero from '../components/fairHero';
import FindDealer from '../components/findDealer';
import Footer from '../components/footer';
import FormPageNavigation from '../components/formPageNavigation';
import FullScreenMediaGallery from '../components/fullScreenMediaGallery';
import GenericPopUp from '../components/genericPopUp';
import Header from '../components/header';
import HeroBanner from '../components/heroBanner';
import InteractiveImage from '../components/interactiveImage';
import LatestNews from '../components/latestNews';
import LightFooter from '../components/lightFooter';
import LightHeader from '../components/lightHeader';
import LiveEventDetail from '../components/liveEventDetail';
import MediaGallery from '../components/mediaGallery';
import MockedComponentMessage from '../components/mockedComponentMessage';
import ModelsListing from '../components/modelsListing';
import NavigationBar from '../components/navigationBar';
import NavigationBarAnchorComponent from '../components/NavigationBarAnchorComponent';
import NewsDetail from '../components/newsDetail';
import NewsFiles from '../components/newsFiles';
import NewsLetterSubscription from '../components/newsLetterSubscription';
import NewsListing from '../components/newsListing';
import NextSteps from '../components/nextSteps';
import ProductBreadcrumbBar from '../components/productBreadcrumbBar';
import ProductBuildAndPriceLink from '../components/productBuildAndPriceLink';
import ProductCompatibleLoaderListing from '../components/productCompatibleLoaderListing';
import ProductDownloadBrochureListing from '../components/productDownloadBrochureListing';
import ProductHeroBanner from '../components/productHeroBanner';
import ProductHeroBannerSeriesDetail from '../components/productHeroBannerSeriesDetail';
import ProductLinesListing from '../components/productLinesListing';
import ProductLineSpecialOffers from '../components/productLineSpecialOffers';
import ProductModelCompatibleAttachmentListing from '../components/productModelCompatibleAttachmentListing';
import ProductModelConfigurations from '../components/productModelConfigurations';
import ProductModelDetailCompatibleLoaders from '../components/productModelDetailCompatibleLoaders';
import ProductModelDetailHeroSection from '../components/productModelDetailHeroSection';
import ProductModelListingByLine from '../components/productModelListingByLine';
import ProductModelNavigation from '../components/productModelNavigation';
import ProductModelsListing from '../components/productModelsListing';
import ProductModelSpecifications from '../components/productModelSpecifications';
import ProductSelector from '../components/productSelector';
import ProductSeoTags from '../components/productSeoTags';
import ProductSeriesCompatibleAttachmentListing from '../components/productSeriesCompatibleAttachmentListing';
import ProductSeriesDetailConfigurationsOverview from '../components/productSeriesDetailConfigurationsOverview';
import ProductSeriesDetailDownloadBrochures from '../components/productSeriesDetailDownloadBrochures';
import ProductSeriesDetailFeature from '../components/productSeriesDetailFeature';
import ProductSeriesDetailModelSpecifications from '../components/productSeriesDetailModelSpecifications';
import ProductSeriesDetailNavigationOverview from '../components/productSeriesDetailNavigationOverview';
import ProductSeriesDetailSpecialOffers from '../components/productSeriesDetailSpecialOffers';
import ProductSeriesDetailTestimonial from '../components/productSeriesDetailTestimonial';
import ProductSeriesListing from '../components/productSeriesListing';
import ProductSeriesListingFilters from '../components/productSeriesListingFilters';
import ProductSeriesNavigationBar from '../components/productSeriesNavigationBar';
import ProductSeriesOverview from '../components/productSeriesOverview';
import ProductSpecialOfferDetail from '../components/productSpecialOfferDetail';
import ProductSpecialOffers from '../components/productSpecialOffers';
import ProductSpecialOffersDetailDownloadBrochures from '../components/ProductSpecialOffersDetailDownloadBrochures';
import ProductSpecialOffersDetailHeroBanner from '../components/ProductSpecialOffersDetailHeroBanner';
import ProductSpecialOffersListing from '../components/productSpecialOffersListing';
import RelatedNews from '../components/relatedNews';
import RemoteBuildAndPrice from '../components/remoteBuildAndPrice';
import SearchResults from '../components/searchResults';
import SitecoreJssForm from '../components/sitecoreJssForm';
import SmallHero from '../components/smallHero';
import SpecCheck from '../components/specCheck';
import SplashComponent from '../components/splashComponent';
import SplitModule from '../components/splitModule';
import SubscriptionBox from '../components/subscriptionBox';
import Table from '../components/table';
import TextModule from '../components/textModule';
import ThankYou from '../components/thankYou';

const components = new Map();
components.set('Advisor', Advisor);
components.set('AnchorTag', AnchorTag);
components.set('BlogNews', BlogNews);
components.set('BreadcrumbBar', BreadcrumbBar);
components.set('BuildAndPriceExternalLink', BuildAndPriceExternalLink);
components.set('CardCarousel', CardCarousel);
components.set('CardColumnLayout', CardColumnLayout);
components.set('CardGrid', CardGrid);
components.set('CustomHtml', CustomHtml);
components.set('DealerLocatorBreadcrumbBar', DealerLocatorBreadcrumbBar);
components.set('DealerLocatorDetail', DealerLocatorDetail);
components.set('DealerLocatorLanding', DealerLocatorLanding);
components.set('DownloadBrochures', DownloadBrochures);
components.set('EventDetail', EventDetail);
components.set('EventsListing', EventsListing);
components.set('ExternalComponent', ExternalComponent);
components.set('FairHero', FairHero);
components.set('FindDealer', FindDealer);
components.set('Footer', Footer);
components.set('FormPageNavigation', FormPageNavigation);
components.set('FullScreenMediaGallery', FullScreenMediaGallery);
components.set('GenericPopUp', GenericPopUp);
components.set('Header', Header);
components.set('HeroBanner', HeroBanner);
components.set('InteractiveImage', InteractiveImage);
components.set('LatestNews', LatestNews);
components.set('LightFooter', LightFooter);
components.set('LightHeader', LightHeader);
components.set('LiveEventDetail', LiveEventDetail);
components.set('MediaGallery', MediaGallery);
components.set('MockedComponentMessage', MockedComponentMessage);
components.set('ModelsListing', ModelsListing);
components.set('NavigationBar', NavigationBar);
components.set('NavigationBarAnchorComponent', NavigationBarAnchorComponent);
components.set('NewsDetail', NewsDetail);
components.set('NewsFiles', NewsFiles);
components.set('NewsLetterSubscription', NewsLetterSubscription);
components.set('NewsListing', NewsListing);
components.set('NextSteps', NextSteps);
components.set('ProductBreadcrumbBar', ProductBreadcrumbBar);
components.set('ProductBuildAndPriceLink', ProductBuildAndPriceLink);
components.set('ProductCompatibleLoaderListing', ProductCompatibleLoaderListing);
components.set('ProductDownloadBrochureListing', ProductDownloadBrochureListing);
components.set('ProductHeroBanner', ProductHeroBanner);
components.set('ProductHeroBannerSeriesDetail', ProductHeroBannerSeriesDetail);
components.set('ProductLinesListing', ProductLinesListing);
components.set('ProductLineSpecialOffers', ProductLineSpecialOffers);
components.set('ProductModelCompatibleAttachmentListing', ProductModelCompatibleAttachmentListing);
components.set('ProductModelConfigurations', ProductModelConfigurations);
components.set('ProductModelDetailCompatibleLoaders', ProductModelDetailCompatibleLoaders);
components.set('ProductModelDetailHeroSection', ProductModelDetailHeroSection);
components.set('ProductModelListingByLine', ProductModelListingByLine);
components.set('ProductModelNavigation', ProductModelNavigation);
components.set('ProductModelsListing', ProductModelsListing);
components.set('ProductModelSpecifications', ProductModelSpecifications);
components.set('ProductSelector', ProductSelector);
components.set('ProductSeoTags', ProductSeoTags);
components.set('ProductSeriesCompatibleAttachmentListing', ProductSeriesCompatibleAttachmentListing);
components.set('ProductSeriesDetailConfigurationsOverview', ProductSeriesDetailConfigurationsOverview);
components.set('ProductSeriesDetailDownloadBrochures', ProductSeriesDetailDownloadBrochures);
components.set('ProductSeriesDetailFeature', ProductSeriesDetailFeature);
components.set('ProductSeriesDetailModelSpecifications', ProductSeriesDetailModelSpecifications);
components.set('ProductSeriesDetailNavigationOverview', ProductSeriesDetailNavigationOverview);
components.set('ProductSeriesDetailSpecialOffers', ProductSeriesDetailSpecialOffers);
components.set('ProductSeriesDetailTestimonial', ProductSeriesDetailTestimonial);
components.set('ProductSeriesListing', ProductSeriesListing);
components.set('ProductSeriesListingFilters', ProductSeriesListingFilters);
components.set('ProductSeriesNavigationBar', ProductSeriesNavigationBar);
components.set('ProductSeriesOverview', ProductSeriesOverview);
components.set('ProductSpecialOfferDetail', ProductSpecialOfferDetail);
components.set('ProductSpecialOffers', ProductSpecialOffers);
components.set('ProductSpecialOffersDetailDownloadBrochures', ProductSpecialOffersDetailDownloadBrochures);
components.set('ProductSpecialOffersDetailHeroBanner', ProductSpecialOffersDetailHeroBanner);
components.set('ProductSpecialOffersListing', ProductSpecialOffersListing);
components.set('RelatedNews', RelatedNews);
components.set('RemoteBuildAndPrice', RemoteBuildAndPrice);
components.set('SearchResults', SearchResults);
components.set('SitecoreJssForm', SitecoreJssForm);
components.set('SmallHero', SmallHero);
components.set('SpecCheck', SpecCheck);
components.set('SplashComponent', SplashComponent);
components.set('SplitModule', SplitModule);
components.set('SubscriptionBox', SubscriptionBox);
components.set('Table', Table);
components.set('TextModule', TextModule);
components.set('ThankYou', ThankYou);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
